import { render, staticRenderFns } from "./NoPhoneSet.vue?vue&type=template&id=557d72e1&scoped=true"
import script from "./NoPhoneSet.vue?vue&type=script&lang=js"
export * from "./NoPhoneSet.vue?vue&type=script&lang=js"
import style0 from "./NoPhoneSet.vue?vue&type=style&index=0&id=557d72e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557d72e1",
  null
  
)

export default component.exports